import { Instagram } from "lucide-react";

export default function Header({ onContact }) {
    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-40 border-b border-[#D4AF37]/20 bg-[#050505]/95 backdrop-blur-sm"
        >
            <div className="mx-auto flex h-16 w-full max-w-6xl items-center justify-between px-4 md:px-6">
                <a
                    href="/"
                    data-testid="brand-link"
                    className="flex items-center gap-2.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37] rounded-md"
                >
                    <span className="flex h-8 w-8 items-center justify-center rounded-lg border border-[#D4AF37]/50 bg-[#101010]">
                        <Instagram className="h-4 w-4 text-[#D4AF37]" strokeWidth={1.8} />
                    </span>
                    <span className="font-heading text-lg font-bold tracking-tight">
                        <span className="text-white">Virat</span>{" "}
                        <span className="text-[#D4AF37]">WorkHub</span>
                    </span>
                </a>
                <button
                    type="button"
                    data-testid="header-contact-button"
                    onClick={onContact}
                    className="rounded-full border border-[#D4AF37]/60 px-4 py-2 text-sm font-semibold text-[#FFD76A] transition-colors duration-200 hover:bg-[#D4AF37]/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#D4AF37]"
                >
                    Contact Us
                </button>
            </div>
        </header>
    );
}
